import { useQuery } from "react-query";
import { PRE_SIGNUP } from "../appConstants/APIEndpoint";
import { requestApiGet } from "./index";
import type { PreSignUpConfig } from "../storage/store";
import { onPreSignupSuccess } from "../services/AuthService";
import { _isEmpty } from "../utils/helpers/zupeeLodash";
import { useTokenStore } from "../storage/tokenState";
import { PARTNER_ID_KEY } from "../appConstants/AppConstant";

const managePartnerId = (partnerId: string) => {
  localStorage.removeItem(PARTNER_ID_KEY);
  if(partnerId){
    localStorage.setItem(PARTNER_ID_KEY, partnerId);
  }
}

const getPreSignupApi = async (partnerId: string): Promise<PreSignUpConfig | null> => {
  try {
    managePartnerId(partnerId);
    const res = await requestApiGet<PreSignUpConfig>(PRE_SIGNUP, {
      headers: { partnerId: partnerId },
    });
    const response = res?.response;
    if (response?.success) {
      const preSignupConfig = response.data;
      if (preSignupConfig) {
        onPreSignupSuccess(preSignupConfig);
        return preSignupConfig;
      }
    } else {
      console.error("Failed to get Pre-signup API: ", response?.error);
    }
  } catch (error) {
    console.error("Error fetching Pre-signup API: ", error);
  }
  return null;
};

export const usePreSignupApi = (partnerId: string = "") => {
  // const {token: userToken} = useTokenStore()
  const staleTime = 5 * 60 * 1000;
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["preSignupApi", partnerId],
    queryFn: () => getPreSignupApi(partnerId),
    retry: false,
    refetchOnWindowFocus: false,
    // enabled: _isEmpty(userToken)
    enabled: Boolean(partnerId), // Only run query if partnerId exists
    staleTime, // Cache results for 5 minutes
  });

  return {
    preSignupConfig: data,
    isLoading,
    error,
    refetch,
  };
};
